import { getRoute, RouteKey } from '@/router/helpers';
import { ScrollAnchorId } from '../scroll-anchor/helpers';
import { FC } from 'react';
import useFeature from '@/hooks/use-feature.hook';
import FlatLink from '../flat-link';

interface Props {
  routeKey: RouteKey;
  scrollId?: ScrollAnchorId;
  size?: 'small' | 'medium';
  search?: Record<string, string>;
}

const PageLink: FC<Props> = ({ routeKey, scrollId, size = 'medium', search }) => {
  const { hasPolicyV2, hasPolicyV1 } = useFeature();

  let versionedRouteKey = routeKey;

  if (hasPolicyV1 && routeKey === 'default-policy') {
    versionedRouteKey = 'default-policy-v1';
  }

  if (hasPolicyV2 && routeKey === 'group-policies') {
    versionedRouteKey = 'scope-policies';
  }

  const { label, icon, link } = getRoute(versionedRouteKey);

  return (
    <FlatLink label={label} icon={icon} to={link} search={search} hash={scrollId} size={size} />
  );
};

export default PageLink;
